import { render, staticRenderFns } from "./mdl-home.vue?vue&type=template&id=22e414b4&"
import script from "./mdl-home.vue?vue&type=script&lang=js&"
export * from "./mdl-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports